import React from 'react';
import withStyles from '@mui/styles/withStyles';
// components
import { CategoryCard } from './index';

const styles = theme => ({
    mainDiv:{
        width:'calc(100% - 20px)',
        justifyContent:'space-between',
        borderRadius:'5px',
        backgroundColor:'#fff',
        padding:'0px 10px 40px 10px',
        marginBottom:'30px',
        boxShadow:'0px 1px 2px #00000038',
        [theme.breakpoints.between('xs','md')]: {
            boxShadow:'none',
            width:'100%',
            backgroundColor:'transparent',
            padding:'10px 0px'
        }
    },

    mainDiv2:{
        width:'calc(100% - 40px)',
        display:'flex',
        flexDirection:'row',
        flexWrap:'wrap',
        alignItems:'stretch',
        justifyContent:'space-between',
        padding:'0px 20px',
        [theme.breakpoints.between('xs','md')]: {
            width:'100%',
            padding:'0px',
        }
    },

    titleDiv:{
        padding:'16px',
        color:'#0F467A',
        fontSize:'16px',
        fontWeight:'bold',
    }
})

// Product list template
function Categories(props) {
    const { classes, categories,fontDarkColor, reference,fontFamily } = props;
    return(
        <div className={classes.mainDiv} ref={reference}>
            <div className={classes.titleDiv}>
            <span style={{fontFamily}}>Select category</span>
            </div>
            <div className={classes.mainDiv2}>
            {React.Children.toArray(categories.map(v=> {
                return(
                    <CategoryCard
                        fontDarkColor={fontDarkColor} // theme color
                        cover={v.photo}
                        name={v.name}
                        categoryId={v.id}
                    />
                )
            }))}
            </div>
        </div>
    )
}

export default withStyles(styles)(Categories);